import { ListTodo } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { DevTrackerPage } from './pages/DevTrackerPage'

/**
 * Dev Tracker (docs/specs/dev_tracker_spec.md) — read-only board of
 * cross-repo dev work. No transition endpoint exists yet (Phase 4), so
 * this is observational only, same category as Action History — hence
 * navSection 'admin' rather than adding a new nav section for a single
 * module (per Foundation Docs/04-module-manifest-architecture.md, a new
 * NavSection value is an amendment; reusing 'admin' isn't).
 */
export default defineModule({
  id: 'dev-tracker',
  name: 'Dev Tracker',
  shortName: 'Dev',
  icon: ListTodo,
  navSection: 'admin',
  navOrder: 21,
  navCollapsedForRoles: ['viewer'],
  urlNamespace: '/dev-tracker',
  routes: [{ path: '/', element: DevTrackerPage, label: 'Dev Tracker' }],
  // Internal engineering visibility only — not a general ops concern.
  permissions: ['admin'],
  densityDefault: 'comfortable',
  filterRailDefault: 'collapsed',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g d t',

  commandPaletteEntries: [
    {
      label: 'Go to Dev Tracker',
      keywords: ['dev', 'tracker', 'sprint', 'board', 'queue', 'needs chris'],
      path: '/',
      group: 'modules',
      shortcut: 'g d t',
    },
  ],
})
